module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_04_6DD79_1SE_G9K.4a8d8de0.png";